var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputPolynominal',{attrs:{"f":_vm.f,"g":_vm.g},on:{"finish":_vm.start}}),(_vm.valid)?_c('EuclidPolynominal',{attrs:{"f":_vm.f,"g":_vm.g}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }